import { render, staticRenderFns } from "./BinderPDFSignatureList.vue?vue&type=template&id=08da4e91&"
import script from "./BinderPDFSignatureList.vue?vue&type=script&lang=js&"
export * from "./BinderPDFSignatureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports